module.exports = __webpack_public_path__ + "static/media/check_in_events.99460080.png";